export const environment = {
  production: false,

  REALM: "banking",

  /*
  CLIENT_ID : 'frontend-credit-factory',
  AUTH_RACINE_URL: 'http://172.16.10.3:8091/auth',
  BACKEND_RACINE_URL: 'http://localhost:7087/cm-backend/',
  APP_SIGNATURE_URL: 'http://172.16.10.3:8088/signerapp',
  */

  
  /*
  CLIENT_ID : 'frontend-credit-factory',
  AUTH_RACINE_URL: 'https://onpoint.oworkflow.com/auth',
  BACKEND_RACINE_URL: 'https://onpoint.oworkflow.com/cm-backend/',
  APP_SIGNATURE_URL: 'https://onpoint.oworkflow.com/signerapp',
  */

  /*
  CLIENT_ID : 'frontend-credit-factory-test',
  AUTH_RACINE_URL: 'https://test-onpoint.oworkflow.com/auth',
  BACKEND_RACINE_URL: 'https://test-onpoint.oworkflow.com/cm-backend-test/',
  APP_SIGNATURE_URL: 'https://onpoint.oworkflow.com/signerapp',
  */

  /*
  CLIENT_ID : 'frontend-credit-factory-bni',
  AUTH_RACINE_URL: 'https://test_bni.oworkflow.com/auth',
  BACKEND_RACINE_URL: 'https://test_bni.oworkflow.com/cm-backend-bni/',
  APP_SIGNATURE_URL: 'https://onpoint.oworkflow.com/signerapp',
  */

  /*
  CLIENT_ID : 'frontend-credit-factory',
  AUTH_RACINE_URL: 'https://test_bpci.oworkflow.com/auth',
  BACKEND_RACINE_URL: 'https://test_bpci.oworkflow.com/cm-backend/',
  APP_SIGNATURE_URL: 'https://onpoint.oworkflow.com/signerapp',
  */

  
  CLIENT_ID : 'frontend-credit-factory',
  AUTH_RACINE_URL: 'https://banquepopulaire.oworkflow.com/auth',
  BACKEND_RACINE_URL: 'https://banquepopulaire.oworkflow.com/cm-backend/',
  APP_SIGNATURE_URL: 'https://onpoint.oworkflow.com/signerapp',
  
  
};
